import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

let shown = false;

export const WinbackToast = () => {
  const { user } = useAuth();
  const { t } = useI18n();
  const n = user?.winback_claimed || 0;
  useEffect(() => {
    if (!n || shown) return;
    shown = true;
    toast.success(t("wb.toast").replace("{n}", n), { duration: 10000, id: "winback-toast" });
  }, [n, t]);
  return null;
};
